import { useDispatch, useSelector } from 'react-redux';
import { OpenOptions, dialogOpened, dialogClosed, DialogNames } from 'redux-implementations/dialog';
import State, { Dialog } from 'types/State';

type HookOpenOptions = Partial<Omit<OpenOptions, 'name'>>;

export default function useDialog(
  dialogName: DialogNames
): {
  open: (options?: HookOpenOptions) => void;
  close: () => void;
  isShown: boolean;
} {
  const dialogState = useSelector<State, Dialog>((state) => state?.dialog?.[dialogName]);
  const isShown = dialogState?.isShown || false;
  const dispatch = useDispatch();
  const open = (options: HookOpenOptions = {}): void => {
    dispatch(dialogOpened({ name: dialogName, ...options }));
  };
  const close = (): void => {
    dispatch(dialogClosed(dialogName));
  };

  return { open, close, isShown };
}
